// Build-time shim for TradingView charting_library.
// The real library (8MB) is too large to bundle with Node 10 build tools.
// It is loaded at runtime via <script type="module"> in public/index.html,
// which populates window.__ChartingLib before Vue mounts.
//
// With Node 16+ you can replace this shim by updating the alias in vue.config.js
// to point directly to public/charting_library/charting_library.esm.js.

export class widget {
  constructor(options) {
    const lib = window.__ChartingLib;
    if (!lib || !lib.widget) {
      console.error('[charting_library] Real library not yet loaded. Retrying...');
      setTimeout(() => {
        const retryLib = window.__ChartingLib;
        if (retryLib && retryLib.widget) {
          this._instance = new retryLib.widget(options);
        }
      }, 500);
      return;
    }
    this._instance = new lib.widget(options);
    return this._instance;
  }
}

export function version() {
  const lib = window.__ChartingLib;
  return lib && lib.version ? lib.version() : 'shim';
}
